import { connect } from 'react-redux';

import { isRequestFailedSelector } from 'src/store/touristsValidation/selectors';
import { showPopup } from 'src/store/feedback/slices';

import { ValidationRequestFailed } from './ValidationRequestFailed';

const mapStateToProps = (state) => ({
  isVisible: isRequestFailedSelector(state),
});

const mapDispatchToProps = {
  onClick: showPopup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ValidationRequestFailed);
